// Les textes du module, en français. Même jeu de clés que es.js — voir son en-tête.

export default {
  errors: {
    REPORT_SCHEDULE_OWNER_ONLY: 'Un rapport planifié s’exécute avec les droits de son auteur : lui seul peut le modifier.',
  },
  // Como se llama este modulo en las pantallas de la plataforma (el
  // selector de la demo, Roles, Auditoria). Sin esto salen listando el
  // slug en ingles, que se lee como un modulo a medio hacer.
  modules: { reports: 'Rapports' },

  reports: {
    assistant: {
      save: {
        action: 'Enregistrer un rapport',
        field: { title: 'Nom', sections: 'Sections', period: 'Période' },
        after: 'Ce sont les questions qui sont enregistrées : à l\'ouverture, les chiffres sont recalculés',
        outcome: 'Rapport « {title} » enregistré',
      },
      schedule: {
        action: 'Envoyer un rapport selon un calendrier',
        summary: {
          daily: 'Envoyer « {title} » chaque jour à {hour}:00',
          weekly: 'Envoyer « {title} » chaque semaine (jour {day}) à {hour}:00',
          monthly: 'Envoyer « {title} » chaque mois, le {day}, à {hour}:00',
          quarterly: 'Envoyer « {title} » chaque trimestre, le {day}, à {hour}:00',
        },
        frequency: { daily: 'Chaque jour', weekly: 'Chaque semaine', monthly: 'Chaque mois', quarterly: 'Chaque trimestre' },
        field: {
          report: 'Rapport',
          frequency: 'Fréquence',
          weekday: 'Jour de la semaine (1 = lundi)',
          monthDay: 'Jour du mois',
          hour: 'Heure',
          recipients: 'À',
        },
        you: 'Vous',
        where: 'Rapport',
        notSaved: 'Aucun rapport enregistré sous ce nom : enregistrez-le d\'abord, puis planifiez-le',
        asOwner: 'Il est calculé avec vos droits à chaque envoi',
        outcome: '« {title} » planifié',
      },
    },
    title: 'Rapports',
    subtitle: 'Les chiffres de toute la maison, et ce qu\'ils veulent dire',
    guide: 'Chaque onglet est un module installé qui sait mesurer quelque chose. C\'est ce '
      + 'module qui calcule les chiffres, avec vos droits : il n\'y a ici aucune copie de ses données.',

    period: 'Période',
    total: 'Total',

    nav: {
      saved: 'Enregistrés',
      explore: 'Explorer',
    },

    kind: {
      report: 'Rapport',
      board: 'Tableau',
    },

    tabs: {
      all: 'Toute l\'entreprise',
    },

    empty: {
      title: 'Rien à mesurer pour l\'instant',
      hint: 'Les rapports viennent des modules installés. Installez-en un — facturation, '
        + 'chantiers, achats — et son onglet apparaît tout seul.',
    },

    actions: {
      save: 'Enregistrer',
      cancel: 'Annuler',
      edit: 'Modifier',
      done: 'Terminé',
      remove: 'Retirer',
    },

    fields: {
      title: 'Nom',
      description: 'Description',
      modules: 'D\'où viennent les chiffres',
      visibility: 'Qui le voit',
      lastRun: 'Vu la dernière fois',
    },

    severity: {
      critical: 'Grave',
      warning: 'Alerte',
      info: 'Info',
      good: 'Bonne nouvelle',
    },

    summary: {
      title: 'Lecture des chiffres',
      subtitle: 'Écrite sur les nombres ci-dessous, et sur eux seuls',
      generate: 'Lire les chiffres',
      again: 'Les relire',
      working: 'Lecture des chiffres…',
      idleTitle: 'Pas encore de lecture',
      idleHint: 'Cela prend quelques secondes et consomme du budget IA, donc on la demande.',
      quiet: 'Rien de notable sur cette période.',
      caveat: 'C\'est une lecture des chiffres ci-dessous, pas un chiffre de plus. Les nombres '
        + 'sont le rapport ; ceci en est une opinion.',
      evidence: 'Sur quoi cela repose',
      impact: 'Ce qui est en jeu',
      cause: 'Cause possible',
      action: 'Que faire',
      confidence: {
        high: 'confiance élevée',
        medium: 'confiance moyenne',
        low: 'confiance faible',
      },
      unavailable: {
        DISABLED: 'La lecture automatique est désactivée dans les réglages du module.',
        NO_DATA: 'Il n\'y a pas assez de chiffres sur cette période pour dire quoi que ce soit.',
        UNREADABLE: 'La réponse n\'a pas pu être lue. Réessayez.',
        AI_PROVIDER_ERROR: 'Le fournisseur d\'IA n\'a pas répondu. Les chiffres ci-dessous sont bons.',
        generic: 'La lecture n\'est pas disponible pour le moment.',
      },
    },

    kpis: {
      title: 'Les chiffres',
      subtitleAll: 'Ce que chaque module installé met en avant',
      subtitleModule: 'Ce que {module} met en avant',
      empty: 'Aucun module n\'a renvoyé de chiffres pour cette période',
      failed: 'Impossible de lire les chiffres de : {modules}',
    },

    changes: {
      title: 'Ce qui a changé',
      subtitle: 'Classé par ce qui est en jeu, pas par le pourcentage',
      emptyTitle: 'Rien n\'a assez bougé',
      emptyHint: 'Le seuil se règle dans la configuration du module.',
    },

    insights: {
      title: 'Ce que vous devriez savoir',
      subtitle: 'Ce que les modules ont signalé sans qu\'on le leur demande',
      emptyTitle: 'Rien à signaler',
      emptyHint: 'C\'est une bonne nouvelle : rien n\'a franchi les limites que vous avez posées.',
      why: 'Pourquoi ?',
      acknowledge: 'Je sais',
    },

    focus: {
      subtitle: 'Le même chiffre, mois par mois. Cliquez une ligne pour descendre d\'un niveau.',
      open: 'Ouvrir dans Explorer',
      close: 'Fermer',
    },

    chart: {
      empty: 'Rien à dessiner',
    },

    widget: {
      noRows: 'Aucune ligne sur cette période',
      nothing: 'Non calculé',
      failed: 'Impossible à calculer',
      truncated: 'Les {shown} premières lignes sont affichées. Les totaux couvrent tout.',
    },

    quality: {
      generic: 'Remarque sur les données : {code}',
      NO_DATA: 'Aucune donnée sur cette période.',
      SHORT_HISTORY: 'Seulement {points} périodes d\'historique : trop peu pour parler de tendance.',
      NOT_ENOUGH_FOR_FORECAST: 'Avec {points} périodes, rien ne peut être projeté sérieusement.',
      MOSTLY_EMPTY: '{empty} des {points} périodes sont vides.',
      INVOICES_WITHOUT_DUE_DATE: '{percent} % des factures n\'ont pas d\'échéance, elles ne '
        + 'peuvent donc pas ressortir comme échues.',
      INVOICE_LINES_WITHOUT_COST: '{percent} % des factures ne portent pas de coût sur leurs '
        + 'lignes : la marge paraît meilleure qu\'elle ne l\'est.',
      QUOTES_LOST_WITHOUT_REASON: '{percent} % des devis perdus n\'indiquent pas pourquoi.',
      CUSTOMERS_WITHOUT_SECTOR: '{percent} % des clients n\'ont pas de secteur.',
      PROJECTS_WITHOUT_BUDGET: '{percent} % des chantiers ouverts n\'ont pas de coût budgété, '
        + 'ils ne peuvent donc pas ressortir en dépassement.',
      PROJECTS_WITHOUT_COST: '{percent} % des chantiers ouverts n\'ont aucun coût imputé.',
      ORDERS_WITHOUT_EXPECTED_DATE: '{percent} % des commandes n\'ont pas de date prévue.',
      MATERIALS_WITHOUT_COST: '{percent} % du matériel en stock n\'a pas de coût : la '
        + 'valorisation est sous-estimée.',
      ORDERS_WITHOUT_ESTIMATE: '{percent} % des ordres terminés n\'avaient pas d\'heures estimées.',
      REFUELS_WITHOUT_PRICE: '{percent} % des pleins ne portent pas de montant.',
      ATTENDANCE_DAYS_LEFT_OPEN: '{count} journées ({percent} %) n\'ont jamais été clôturées : '
        + 'leurs heures sont comptées jusqu\'à maintenant.',
      ATTENDANCE_PERIOD_TOO_LARGE: 'La période contient plus de {limit} pointages et a été '
        + 'coupée. Demandez une période plus courte.',
    },

    findings: {
      metric_moved: '« {metric} » : {percent} % par rapport à la période précédente.',
      module_insight: 'Un module a signalé quelque chose.',
      invoices_overdue: '{count} factures sont échues, la plus ancienne depuis {days} jours '
        + '({amount} €).',
      customer_concentration: '{name} représente {percent} % de ce qui a été facturé sur la période.',
      customers_gone_quiet: '{count} clients actifs n\'ont pas été facturés depuis des mois. Le '
        + 'plus important est {name}, il y a {months} mois.',
      quotes_gone_quiet: '{count} devis envoyés il y a plus d\'un mois sont toujours sans '
        + 'réponse ({amount} €).',
      projects_over_budget: '{count} chantiers ouverts dépassent leur budget. {code} de '
        + '{percent} %.',
      supplier_concentration: '{name} représente {percent} % de ce qui a été acheté sur la période.',
      supplier_delivering_late: '{name} livre avec {days} jours de retard en moyenne, sur '
        + '{orders} commandes.',
      stock_not_moving: '{count} matériaux n\'ont pas bougé depuis un an, pour {amount} €.',
      product_over_estimate: '{name} prend {percent} % de temps de plus que prévu, sur {orders} '
        + 'ordres.',
      field_incident_rate: '{rate} incidents pour 100 ordres de travail sur la période.',
      maintenance_overdue: '{count} plans de maintenance sur {total} sont en retard, le plus '
        + 'ancien de {days} jours.',
      asset_repeat_failures: '{name} est tombée en panne {count} fois sur la période, pour '
        + '{hours} heures d\'arrêt.',
      absences_awaiting_approval: '{count} demandes d\'absence attendent une réponse, la plus '
        + 'ancienne depuis {days} jours.',
      personnel_documents_expired: '{count} documents du personnel sont périmés.',
      personnel_documents_expiring: '{count} documents du personnel expirent sous un mois, pour '
        + '{people} personnes.',
      market_cost_exposure: '{name} a bougé de {percent} % : environ {amount} € par an '
        + '(confiance {confidence} %).',
      leads_unanswered: '{count} demandes venues du site sont sans réponse, la plus ancienne '
        + 'depuis {days} jours.',
    },

    filters: {
      period: 'Période',
      from: 'Du',
      to: 'Au',
      compare: 'Comparer avec',
    },

    periods: {
      this_month: 'Ce mois-ci',
      last_month: 'Le mois dernier',
      this_quarter: 'Ce trimestre',
      last_quarter: 'Le trimestre dernier',
      this_year: 'Cette année',
      last_year: 'L\'année dernière',
      year_to_date: 'Depuis le début de l\'année',
      last_7_days: '7 derniers jours',
      last_30_days: '30 derniers jours',
      last_90_days: '90 derniers jours',
      last_6_months: '6 derniers mois',
      last_12_months: '12 derniers mois',
      all_time: 'Tout l\'historique',
      custom: 'Entre deux dates',
    },

    compare: {
      previous_period: 'La période précédente',
      previous_year: 'La même période l\'an dernier',
      none: 'Rien',
    },

    visualisations: {
      kpi: 'Un chiffre',
      line: 'Courbe',
      area: 'Aire',
      bar: 'Barres',
      stacked_bar: 'Barres empilées',
      pie: 'Camembert',
      donut: 'Anneau',
      table: 'Tableau',
    },

    operators: {
      eq: 'est',
      ne: 'n\'est pas',
      in: 'est l\'un de',
      nin: 'n\'est aucun de',
      gt: 'supérieur à',
      gte: 'supérieur ou égal à',
      lt: 'inférieur à',
      lte: 'inférieur ou égal à',
      contains: 'contient',
      between: 'entre',
      exists: 'a une valeur',
    },

    explore: {
      title: 'Explorer',
      subtitle: 'Une question à la fois, sur ce que vous avez installé',
      guide: 'Choisissez un sujet, les chiffres voulus et comment les regrouper. Seul ce que '
        + 'vous pouvez voir apparaît : ce qui n\'est pas dans les listes n\'est pas à vous.',
      question: 'La question',
      dataset: 'Sur quoi',
      datasetHint: 'Chaque module installé apporte les siens.',
      grain: 'Une ligne, c\'est : {grain}',
      metrics: 'Quoi mesurer',
      metricsHint: 'Sans en choisir, ce sont celles que le module met en avant.',
      metricsPlaceholder: 'Tapez et appuyez sur Entrée',
      dimensions: 'Regroupé par',
      dimensionsHint: 'Trois au maximum. Pour affiner davantage, utilisez un filtre.',
      dimensionsPlaceholder: 'Client, secteur, commercial…',
      granularity: 'Dans le temps',
      noGranularity: 'Sans axe de temps',
      autoVisualisation: 'Celle qui convient',
      granularities: {
        auto: 'Automatique',
        day: 'Par jour',
        week: 'Par semaine',
        month: 'Par mois',
        quarter: 'Par trimestre',
        year: 'Par an',
      },
      dateField: 'Quelle date compte',
      dateFieldHint: 'Cela change ce que « en juillet » veut dire.',
      visualisation: 'Comment c\'est dessiné',
      limit: 'Combien de lignes',
      filters: 'Filtres',
      filtersHint: 'Les totaux couvrent toujours tout ce qui passe le filtre.',
      addFilter: 'Ajouter un filtre',
      removeFilter: 'Retirer',
      value: 'Valeur',
      run: 'Calculer',
      save: 'Enregistrer comme rapport',
      saveTitle: 'Enregistrer la question',
      saved: 'Enregistré',
      answerBy: '{metrics} par {dimension}',
      rowCount: '{count} lignes',
      reading: 'Quelle forme cela a',
      readingHint: 'Tendance, valeurs anormales et projection, chacune avec sa fiabilité',
      readingIdle: 'Pas encore analysé',
      analyse: 'Analyser',
      trend: 'Tendance',
      trendUnclear: 'Pas de tendance nette avec {points} périodes.',
      trends: {
        up: 'En hausse de {percent} % par période (ajustement {fit} %).',
        down: 'En baisse de {percent} % par période (ajustement {fit} %).',
        flat: 'Plate.',
        unknown: 'Pas assez de données.',
      },
      anomalies: 'Périodes anormales',
      forecast: 'Projection',
      forecastNone: 'Pas assez d\'historique pour projeter quoi que ce soit.',
      forecastNext: 'Période suivante : {value} (entre {low} et {high}, {confidence}).',
      confidence: {
        high: 'confiance élevée',
        medium: 'confiance moyenne',
        low: 'confiance faible',
        insufficient: 'sans base',
      },
      caveats: 'À lire avec prudence',
    },

    saved: {
      title: 'Rapports enregistrés',
      subtitle: 'Les questions que quelqu\'un a voulu reposer',
      search: 'Rechercher',
      searchPlaceholder: 'Par nom, description ou étiquette',
      module: 'De quel module',
      allModules: 'De tous',
      empty: 'Rien d\'enregistré pour l\'instant',
      never: 'Jamais',
      template: 'Modèle',
      company: 'Toute l\'entreprise',
      shared: 'Partagé',
      private: 'Moi seul',
      scheduled: 'Programmé',
      scopes: {
        all: 'Tous',
        mine: 'Les miens',
        shared: 'Partagés avec moi',
        templates: 'Modèles',
        scheduled: 'Programmés',
      },
    },

    report: {
      loading: 'Ouverture du rapport…',
      periodHint: 'Changer la période ici ne change pas le rapport : c\'est un coup d\'œil, pas '
        + 'une décision.',
      narrate: 'Écrire les conclusions',
      export: 'Exporter',
      schedule: 'Programmer',
      saved: 'Enregistré',
      editing: 'Ajouter au rapport',
      sectionTitle: 'Titre de la section',
      addText: 'Un texte',
      addNarrative: 'Conclusions IA',
      addInsights: 'Les signalements',
      addQuery: 'Une nouvelle question',
      conclusions: 'Conclusions',
      conclusionsHint: 'Écrites sur les chiffres de cette section',
      conclusionsIdle: 'Appuyez sur « Écrire les conclusions » en haut',
      emptyTitle: 'Le rapport est vide',
      emptyHint: 'Ajoutez une question depuis Explorer, ou un texte depuis ici.',
      formats: {
        pdf: 'PDF',
        docx: 'Word',
        csv: 'CSV',
      },
    },

    schedule: {
      title: 'Programmer le rapport',
      hint: 'Il part tout seul, à l\'heure que vous dites, par courriel vers des gens qui n\'ont '
        + 'peut-être pas de compte ici. Il est calculé avec VOS droits.',
      enabled: 'L\'envoyer tout seul',
      frequency: 'À quelle fréquence',
      frequencies: {
        daily: 'Chaque jour',
        weekly: 'Chaque semaine',
        monthly: 'Chaque mois',
        quarterly: 'Chaque trimestre',
      },
      weekday: 'Quel jour de la semaine (1 = lundi)',
      monthday: 'Quel jour du mois',
      hour: 'À quelle heure (UTC)',
      recipients: 'À quelles adresses',
      recipientsHint: 'Des gens de l\'extérieur : le conseil, le cabinet comptable.',
      recipientsPlaceholder: 'courriel{\'@\'}exemple.com',
      roles: 'Et à qui détient ces rôles',
      rolesHint: 'Cela continue de fonctionner quand quelqu\'un part.',
      format: 'Dans quel format',
      saved: 'Programmé',
    },

    export: {
      index: 'Sommaire',
      generated: 'Généré',
    },

    entity: {
      subtitle: 'Ce que chaque module installé sait de cet enregistrement',
      emptyTitle: 'Aucun module n\'en sait quoi que ce soit',
      emptyHint: 'Soit aucun module installé ne le mesure, soit vous n\'avez pas le droit de '
        + 'voir ceux qui le font.',
      failed: 'Ce module n\'a pas pu répondre.',
      open: 'Ouvrir',
      footnote: 'Chaque bloc est calculé par son module, avec vos droits. Aucun chiffre n\'est '
        + 'conservé ici.',
      kinds: {
        customer: 'Client',
        supplier: 'Fournisseur',
        project: 'Chantier',
        user: 'Personne',
        material: 'Matériau',
        asset: 'Machine',
        site: 'Site',
        team: 'Équipe',
        vehicle: 'Véhicule',
      },
    },

    dashboard: {
      findings: 'Signalements ouverts',
      findingsHelp: 'Combien de signalements graves ou d\'alerte ne sont pas marqués comme vus',
      findingsList: 'Ce que vous devriez savoir',
      findingsListHelp: 'Les derniers signalements que les modules ont remontés d\'eux-mêmes',
      mine: 'Mes rapports',
      mineHelp: 'Les rapports que vous avez enregistrés, du plus récemment modifié au plus ancien',
    },

    related: {
      figures: 'Chiffres',
    },

    notifications: {
      categories: {
        insight: 'Signalements de l\'analyse',
      },
      insights: {
        title: 'Il y a quelque chose à regarder',
        body: 'L\'analyse de cette nuit a remonté {count} signalements.',
      },
    },

    analytics: {
      usage: {
        label: 'Rapports enregistrés',
        help: 'Une ligne par rapport enregistré, avec le nombre de fois qu\'il a été ouvert',
      },
      dates: {
        created: 'Quand il a été enregistré',
      },
      metrics: {
        count: 'Rapports',
        runs: 'Fois ouvert',
      },
      dimensions: {
        owner: 'Qui l\'a enregistré',
        kind: 'Rapport ou tableau',
      },
    },
  },

  permissions: {
    reports: {
      read: 'Ouvrir Rapports et poser des questions. Ne donne accès à aucun chiffre : chaque '
        + 'nombre est calculé par son module avec les droits de celui qui demande',
      write: 'Enregistrer ses propres rapports et tableaux',
      share: 'Donner un rapport à quelqu\'un. Partager n\'élargit jamais ce que l\'autre peut voir',
      schedule: 'Mettre un rapport à l\'heure pour qu\'il parte par courriel tout seul',
      manage: 'Modifier et supprimer les rapports de tout le monde, et publier des modèles',
    },
  },

  audit: {
    actions: {
      report: {
        created: 'Rapport créé',
        updated: 'Rapport modifié',
        deleted: 'Rapport supprimé',
        exported: 'Rapport exporté',
      },
    },
  },

  settings: {
    ns: {
      reports: {
        // El nombre de la sección en la pantalla de Ajustes.
        title: 'Rapports',

        alertThresholdPct: {
          label: 'Me prévenir quand un chiffre bouge de plus que cela',
          help: 'Par rapport à la période précédente. Plus bas veut dire plus de signalements '
            + 'et plus de bruit ; une entreprise avec un mois calme à 5 % arrête de les lire.',
        },
        alertMinImpact: {
          label: 'Et seulement si le changement vaut au moins cela',
          help: 'En euros, pour les chiffres en euros. Une hausse de 40 % sur 300 €, c\'est de '
            + 'l\'arithmétique, pas une nouvelle. 0 veut dire que tout changement au-delà du '
            + 'pourcentage compte.',
        },
        alertPeriod: {
          label: 'La période que regarde l\'analyse de chaque nuit',
          help: 'Et elle est comparée à celle qui la précède immédiatement.',
        },
        alertRoles: {
          label: 'Qui est prévenu quand quelque chose d\'important est trouvé',
          help: 'Des rôles, pas des personnes, pour que cela continue quand quelqu\'un part. '
            + 'Seulement le grave et les alertes ; le reste attend à l\'écran.',
        },
        aiSummary: {
          label: 'Laisser l\'assistant écrire la lecture des chiffres',
          help: 'Le bloc en haut de chaque onglet, et les conclusions d\'un rapport exporté. '
            + 'Désactivé, ce sont les nombres et les signalements, sans personne pour écrire '
            + 'dessus. Cela consomme du budget IA à chaque exécution.',
        },
        overviewDatasets: {
          label: 'Combien de sujets couvre l\'onglet de synthèse',
          help: 'L\'onglet de toute l\'entreprise demande à chaque module installé ses chiffres '
            + 'principaux. Avec quinze modules, c\'est un écran lent ; chaque module garde son '
            + 'propre onglet.',
        },
        overviewCharts: {
          label: 'Combien de graphiques dessine l\'onglet de synthèse',
          help: 'Les chiffres arrivent avec leur propre historique et le dessiner ne coûte rien de '
            + 'plus. Ce qui coûte, c\'est l\'écran : passé la demi-douzaine, une synthèse n\'en est '
            + 'plus une. Zéro laisse les tuiles et les constats, chaque graphique à un clic.',
        },
      },
    },

    mail: {
      reports__scheduled_report: {
        label: 'Rapports programmés',
        help: 'La boîte depuis laquelle part le rapport qui s\'envoie tout seul, avec son PDF '
          + 'en pièce jointe.',
      },
    },
  },

  assistant: {
    openers: {
      reports: {
        how_is_it_going: 'Comment va l\'entreprise ce mois-ci ?',
        what_changed: 'Qu\'est-ce qui a changé depuis le mois dernier ?',
        worry: 'De quoi devrais-je me préoccuper ?',
      },
    },
  },
}
